import { render, staticRenderFns } from "./routes.vue?vue&type=template&id=5ddf9f89&scoped=true"
import script from "./routes.vue?vue&type=script&lang=js"
export * from "./routes.vue?vue&type=script&lang=js"
import style0 from "./routes.vue?vue&type=style&index=0&id=5ddf9f89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddf9f89",
  null
  
)

export default component.exports